<template>
  <td :class="[
    'px-3 py-2 whitespace-nowrap',
    !noTextColor && 'text-gray-700 dark:text-dark-50',
    (numeric || rupiahValue !== null) && 'text-right tabular-nums',
    customClass
  ]" :colspan="colspan">
    <!-- Rupiah split display: "Rp" left, number right -->
    <div v-if="rupiahValue !== null" class="flex justify-between items-center gap-2">
      <span class="text-left">Rp</span>
      <span class="text-right tabular-nums">{{ rupiahFormatted }}</span>
    </div>
    <!-- Normal content -->
    <slot v-else></slot>
  </td>
</template>

<script>
export default {
  name: 'TableCell',
  props: {
    noTextColor: {
      type: Boolean,
      default: false
    },
    colspan: {
      type: Number,
      default: 1
    },
    customClass: {
      type: String,
      default: ''
    },
    numeric: {
      type: Boolean,
      default: false
    },
    rupiah: {
      type: [Number, String],
      default: null
    }
  },
  computed: {
    rupiahValue() {
      if (this.rupiah === null || this.rupiah === undefined || this.rupiah === '') return null;
      const num = Number(this.rupiah);
      return isNaN(num) ? null : num;
    },
    rupiahFormatted() {
      if (this.rupiahValue === null) return '';
      return new Intl.NumberFormat('id-ID').format(this.rupiahValue);
    }
  }
}
</script>
